export const removeSpaces = (input: string | undefined): string => {
  if (!input) return '';
  return input.replace(/\s+/g, '');
};

export const isContractAvailableInCountry = (
  doctorCountry: string | undefined,
  availableCountries: string[] | undefined
): boolean => {
  if (
    !doctorCountry ||
    !availableCountries ||
    availableCountries.length === 0
  ) {
    return false;
  }
  const normalizedCountry = removeSpaces(doctorCountry).toUpperCase();
  const normalizedAvailableCountries = availableCountries.map(country =>
    removeSpaces(country).toUpperCase()
  );
  return normalizedAvailableCountries.includes(normalizedCountry);
};
